import { z } from "zod";

export const updateDeparmentSchema = z.object({
  ativo: z.boolean(),
  sigla: z.string().max(10, "Sigla deve ter no máximo 10 caracteres").optional().or(z.literal("")),
  nome: z.string().max(255, "Nome deve ter no máximo 255 caracteres").optional().or(z.literal("")),
});

export type UpdateDepartmentSchemaData = z.infer<typeof updateDeparmentSchema>;
